const requestSheetAsJson = require('../requestSheetAsJson')

const { CLIENT_LIST_SHEET } = require('../../../../functions/globalConstants')

/**
 * スプレッドシートを読み込んでフォームのサジェスト用データを用意する
 * @example
    [
      'カシワバラ',
      '豊田工業',
      '前川建設',
      '佐藤建設',
      'マルイチ',
    ]
 * @see https://developers.google.com/gdata/samples/spreadsheet_sample
 * @see https://gist.github.com/terrywbrady/a03b25fe42959b304b1e
 */
const fetchClientList = async () =>
  // スプレッドシートをJSONで取ってくる
  requestSheetAsJson(CLIENT_LIST_SHEET).then(entries => entries
    // 必要なデータだけ抜き出す
    .map(entry => ({
      sortOrder: parseInt(entry['表示順']),
      name: entry['省略名'],
    }))
    // ソートする
    .sort((a, b) => a.sortOrder - b.sortOrder)
    // 名前だけにする
    .map(member => member.name),
  )

module.exports = fetchClientList
